
export type UpdateChatThreadLastMessageBody = {
  lastMessage: string;
  lastMessageTime: string;
};
